import { SupportedDailyWeeklyRentalTypes } from 'enums/supportedRentalTypes';
import { FormAction } from 'hooks/useForm';
import { Dispatch, useEffect, useMemo } from 'react';
import { VehicleBasedDailyWeeklyDemandState } from 'types/demand.type';

export function usePriceWidgetDWPeopleLimits(
  state: VehicleBasedDailyWeeklyDemandState,
  dispatch: Dispatch<FormAction<VehicleBasedDailyWeeklyDemandState>>,
  cruisingCapacity: number,
  overnightCapacity: number
) {
  const MAX_PEOPLE = useMemo(
    () =>
      state.demandVariant === SupportedDailyWeeklyRentalTypes.HALF_DAY
        ? cruisingCapacity
        : overnightCapacity,
    [state, cruisingCapacity, overnightCapacity]
  );

  const MIN_PEOPLE = useMemo(() => 1, []);

  useEffect(() => {
    if (+state.numberOfPeople > MAX_PEOPLE) {
      dispatch({
        type: 'numberOfPeople',
        payload: `${MAX_PEOPLE}`,
      });
    }
  }, [state.numberOfPeople, MAX_PEOPLE]);

  return {
    MAX_PEOPLE,
    MIN_PEOPLE,
  };
}
